import React from 'react'

export const YouTubeIcon = () => (
  <svg width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M19.615 3.184c-3.604-.246-11.631-.245-15.23 0C.488 3.45.029 5.804 0 12c.029 6.185.484 8.55 4.385 8.816 3.6.245 11.626.246 15.23 0C23.512 20.55 23.971 18.196 24 12c-.029-6.185-.484-8.549-4.385-8.816zM9 16V8l8 3.993L9 16z'
      fill='#FFF'
    />
  </svg>
)
